import fetch from 'cross-fetch';

const API_BASE = 'https://pdfapi.rockdelux.com/production';
const POLL_INTERVAL = 3000;

// Starts an async job on the PDF API and polls until its worker has written
// the result. Splitting and text extraction both take longer than the 29 s
// API Gateway allows for a big issue, so neither can answer synchronously.
const runPdfJob = async ({
  key, startPath, resultPath, timeout, label,
}) => {
  const response = await fetch(`${API_BASE}${startPath}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ key }),
  });

  if (response.status >= 400) {
    throw new Error(`Could not start PDF ${label}`);
  }

  const { jobId } = await response.json();
  const startTime = Date.now();

  // Polling is sequential on purpose: each request waits for the previous one.
  /* eslint-disable no-await-in-loop */
  while (Date.now() - startTime < timeout) {
    const resultResponse = await fetch(`${API_BASE}${resultPath}?jobId=${jobId}&_t=${Date.now()}`, {
      cache: 'no-store',
    });

    if (resultResponse.status >= 400) {
      throw new Error(`Error retrieving PDF ${label} result`);
    }

    const result = await resultResponse.json();

    if (result.status !== 'processing') {
      return result;
    }

    await new Promise(resolve => setTimeout(resolve, POLL_INTERVAL));
  }
  /* eslint-enable no-await-in-loop */

  throw new Error(`PDF ${label} timed out`);
};

export default runPdfJob;
